import { ContentfulClient } from 'react-contentful';

/* eslint-disable */
// @ts-ignore
export const contentfulClient = new (ContentfulClient as any)({
    accessToken: 'kEKzn-azJLmPT1dJ9ImR3_ZGiHJLVQWgKz2C8sUIJdA',
    space: 'ugrk3agvf6n8',
});
